import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Link, useLocation, useParams } from "react-router-dom";
import { Config } from "../../Config";
import axios from "axios";
import Loader from "../Loader";
import swal from "sweetalert";

export const toCommaSeprated = (value) => {
  // Handle null, undefined, or empty values
  if (value === null || value === undefined || value === '') {
    return '--';
  }
  
  // If value is already a string with commas, return it
  if (typeof value === 'string' && value.includes(',')) {
    return value;
  }
  
  if (isNaN(value)) {
    return value;
  }
  
  const numStr = value.toString();
  if (numStr.includes(".")) {
    return numStr;
  }
  
  const len = numStr.length;
  if (len <= 3) {
    return numStr;
  } else if (len <= 5) {
    return numStr.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  } else {
    const firstPart = numStr.slice(0, len - 3);
    const lastPart = numStr.slice(len - 3);
    return firstPart.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastPart;
  }
};

// Helper function to parse price data - handles both comma-separated and simple array formats
const parsePriceData = (priceString) => {
  try {
    const parsed = JSON.parse(priceString || "[]");
    
    // Check if it's the new format (array of comma-separated strings)
    if (parsed.length > 0 && typeof parsed[0] === 'string' && parsed[0].includes(',')) {
      // Format: ["Ground Floor,337.60,22500,49000,..."]
      return parsed.map(item => item.split(','));
    } else {
      // Format: ["101","101","101",...]
      return [parsed];
    }
  } catch (error) {
    console.error("Error parsing price data:", error);
    return [[]];
  }
};

const Swarnim1 = () => {
  const location = useLocation();
  const [projectName, setProjectName] = useState("");
  const [loading, setLoading] = useState(true);
  const [drop_sizes, setdrop_sizes] = useState([]);
  const [terms, setTerms] = useState([]);
  const [labels, setLabels] = useState([]);
  const [priceList, setpriceList] = useState([]);
  const [price, setPrice] = useState([]);
  const [priceList1, setPriceList1] = useState([]);
  const [into, setIntro] = useState([]);
  const [project_download, setProjectDownload] = useState([]);
  const { projectname } = useParams();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  function capitalizeText(text) {
    return text.toLowerCase().replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
  }

  useEffect(() => {
    if (projectname) {
      const p_name = capitalizeText(projectname.replaceAll("-", " "));
      if (localStorage.getItem("projectName") !== p_name) {
        localStorage.setItem("projectName", p_name);
      }
      setProjectName(p_name);
    }
  }, [projectname]);

  useEffect(() => {
    if (location.state?.project) {
      setProjectName(location.state.project);
      localStorage.setItem("projectName", location.state.project);
    } else {
      const savedProjectName = localStorage.getItem("projectName");
      if (savedProjectName) {
        setProjectName(savedProjectName);
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (!projectName) return; // Skip fetching if projectName is not set

    axios
      .get(`${Config.apiUrl}/project_info`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const data = response.data.project_page || {};
        setTerms(data.terms || []);
        setpriceList(data.price_list || []);
        setPrice(data.price || []);
        setPriceList1(data.price_list1 || []);
        setIntro(data.intro || []);
        setLabels(data.price_label || []);
        setProjectDownload(data.project_download || []);

        // Set drop_sizes based on priceList1 array
        const filteredPriceList1 = (data.price_list1 || []).filter(
          (p) => p.project_name === projectName
        );
        
        if (filteredPriceList1.length > 0) {
          const dropSizes = [];
          filteredPriceList1.forEach((p) => {
            const priceData = parsePriceData(p.price);
            priceData.forEach((row) => {
              if (row.length > 0) {
                // Handle both formats
                const sizeValue = row[1] || row[0] || '';
                const amountValue = row[3] || '';
                dropSizes.push({
                  size: sizeValue,
                  title: `${sizeValue} Sq.Ft Amount ${toCommaSeprated(amountValue)}`,
                });
              }
            });
          });
          setdrop_sizes(dropSizes);
        } else {
          // Fallback to old price array if priceList1 is empty
          setdrop_sizes(
            (data.price || [])
              .filter((p) => p.project_name === projectName)
              .map((p) => ({
                size: p.size,
                title: `${p.size || ''} Sq.Ft Amount ${toCommaSeprated(p.registration_amount)}`,
              }))
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem fetching the data:", error);
        setLoading(false);
      });
  }, [projectName]);

  const [columnVisibility, setColumnVisibility] = useState({
    size: true,
    rate: true,
    registration_amount: true,
    allotment: true,
    plc: true,
    oc: true,
    other_charges: true,
    total_cost: true,
    apply: true,
  });

  const getLabelsByProjectId = (projectId) => {
    return (labels || [])
      .filter((item) => item.project_id === projectId)
      .map((item) => item.label);
  };

  useEffect(() => {
    if (price?.length > 0) {
      const firstRow = price.find((item) => item.project_name === projectName);
      if (firstRow) {
        const visibility = {};
        Object.keys(firstRow).forEach((column) => {
          visibility[column] = firstRow[column] !== null;
        });
        setColumnVisibility(visibility);
      }
    }
  }, [price, projectName]);

  return (
    <>
      {loading && <Loader />}
      <Navbar />
      <div className="projdetails" style={{ minHeight: "100vh" }}>
        <div className="text-center mt-5">
          <h2 className="fw-bold text-capitalize">{projectName || "Loading..."}</h2>
          <div className="line mt-4 mb-5 mx-auto"></div>
        </div>
        {(into || []).length > 0 && (
          <section className="pb-5">
            <div className="container-box">
              {(into || [])
                .filter((term) => term.project_name === projectName)
                .map((term, index) => (
                  <div key={index} className="table-responsive">
                    <div
                      className="project_details"
                      dangerouslySetInnerHTML={{
                        __html: term?.description?.replaceAll(/ style="[^"]*"/g, "") || "",
                      }}
                    />
                  </div>
                ))}
            </div>
          </section>
        )}

        {(priceList1 || []).length > 0 && (
          <section className="py-5 bg-light-blue" id="pricelist">
            <div className="container-box">
              <h2 className="fw-bold mb-4">Price List & Area</h2>
              <div className="table-responsive">
                <table
                  className="table table-bordered border-secondary text-center"
                  style={{ verticalAlign: "middle" }}
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      {(labels || [])
                        .filter((term) => term.project_name === projectName)
                        .slice()
                        .reverse()
                        .map((item, index) => (
                          <th key={index}>{item.label}</th>
                        ))}
                      <th>Apply</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(priceList1 || [])
                      .filter((item) => item.project_name === projectName)
                      .slice()
                      .reverse()
                      .map((priceListItem, itemIndex) => {
                        const priceData = parsePriceData(priceListItem.price);
                        
                        return priceData.map((row, rowIndex) => {
                          const globalIndex = itemIndex * priceData.length + rowIndex;
                          const sizeValue = row[1] || row[0] || '';
                          const amountValue = row[3] || '';
                          
                          return (
                            <tr key={`${itemIndex}-${rowIndex}`}>
                              <td>{globalIndex + 1}</td>
                              {row.map((priceValue, colIndex) => (
                                <td key={colIndex}>{toCommaSeprated(priceValue)}</td>
                              ))}
                              <td>
                                {priceListItem.status === 0 ? (
                                  <div
                                    className="text-decoration-none text-red"
                                    onClick={() => swal("Registration Closed", "", "warning")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Registration Closed
                                  </div>
                                ) : priceListItem.status === 2 ? (
                                  <div className="text-decoration-none text-gray">NA</div>
                                ) : (
                                  <Link
                                    to={`${Config.appUrl}register`}
                                    state={{
                                      index: globalIndex,
                                      size: sizeValue ? `${sizeValue} Sq.Ft Amount ${toCommaSeprated(amountValue)}` : '',
                                      project: projectName,
                                      sizes: drop_sizes,
                                    }}
                                    className="text-decoration-none text-red"
                                  >
                                    Registration Open
                                  </Link>
                                )}
                              </td>
                            </tr>
                          );
                        });
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        {(terms || []).length > 0 && (
          <section className="py-5">
            <div className="container-box">
              <div className="row align-items-center justify-content-between">
                <div className="col-md-8">
                  <h2 className="fw-bold mb-4">Terms & Condition</h2>
                  <div>
                    {(terms || [])
                      .filter((term) => term.project_name === projectName)
                      .map((term, index) => (
                        <div key={index} dangerouslySetInnerHTML={{ __html: term.description || "" }} />
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {(project_download || []).length > 0 && (
          <section className="py-5 bg-light-blue">
            <div className="container-box py-md-4">
              <h2 className="fw-bold mb-4">Downloads Section</h2>
              <div className="table-responsive">
                <table className="table w-100 table-bordered">
                  <thead>
                    <tr>
                      <th className="col-1 text-center">Sr No.</th>
                      <th>Document Type</th>
                      <th className="text-center">Status</th>
                      <th className="col-2 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(project_download || [])
                      .filter((item) => item.project_name === projectName)
                      .map((item, index) => (
                        <tr key={index}>
                          <td className="h-auto text-center">{index + 1}</td>
                          <td className="h-auto text-capitalize">{item.document_name || "--"}</td>
                          <td className="h-auto text-capitalize text-center">Approved</td>
                          <td className="h-auto text-center">
                            <a
                              href={`${Config.docUrl}/${item.download_pdf}`}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-sm btn-success btn-width"
                              download={true}
                            >
                              <i className="bi bi-download me-2"></i>
                              Download
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default Swarnim1;